import React, { createContext, useState, useContext } from 'react'

const InternationalCalculatorContext = createContext([{}, () => {}]) 

const InternationalCalculatorProvider = ({ children, initialService }) => {
    const [serviceType, setService] = useState(initialService)
    const [dimensions, setDimensions] = useState({
        weight: '',
        length: '',
        width: '',
        height: ''
    })  
    const [postalNumber, setPostalNumber] = useState('')  
    const [destination, setDestination] = useState('')  
    const [countryQuery, setCountryQuery] = useState('')  
    const [filteredCountries, setFilteredCountries] = useState([])  
    const [showDropdown, setShowDropdown] = useState(false)  
    const [highlightedIndex, setHighlightedIndex] = useState(-1)  

    const [errorInput, setInputError] = useState(null)  
    const [errorSelect, setErrorSelect] = useState(null)  
    const [errorInputPostalCode, setErrorInputPostalCode] = useState(null)  

    const [submittedDimensions, setSubmittedDimensions] = useState({
        length: '',
        width: '',
        height: ''
    })  
    const [countries, setCountries] = useState([])

    const [priceValue, setPrice] = useState(null)
    const [priceValueAdditional, setAdditionalPrice] = useState(null)
    const [zoneCount, setZoneCount] = useState(null)
    const [maxWeight, setMaxWeight] = useState(null)
    const [descriptionText, setDescriptionText] = useState(null)
    const [subDisplayCategory, setSubDisplayCategory] = useState(null)
    const [shippingWeightValue, setShippingWeight] = useState('')
    const [workingDays, setWorkingDays] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
 
    return (
        <InternationalCalculatorContext.Provider value={{
            serviceType, setService,
            dimensions, setDimensions,
            postalNumber, setPostalNumber,
            destination, setDestination,
            countryQuery, setCountryQuery,
            filteredCountries, setFilteredCountries,
            showDropdown, setShowDropdown,
            highlightedIndex, setHighlightedIndex,
            errorInput, setInputError,
            errorSelect, setErrorSelect,
            errorInputPostalCode, setErrorInputPostalCode,
            submittedDimensions, setSubmittedDimensions,
            countries, setCountries,
            priceValue, setPrice,
            priceValueAdditional, setAdditionalPrice,
            zoneCount, setZoneCount,
            maxWeight, setMaxWeight,
            descriptionText, setDescriptionText,
            subDisplayCategory, setSubDisplayCategory,
            shippingWeightValue, setShippingWeight,
            workingDays, setWorkingDays,
            loading, setLoading,
            error, setError
        }}>
        {children}
        </InternationalCalculatorContext.Provider>
    )
}

export { InternationalCalculatorContext, InternationalCalculatorProvider }